import { useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import InventoryList from '../components/inventory/InventoryList';
import InventoryDetail from '../components/inventory/InventoryDetail';
import EditDrawer from '../components/inventory/EditDrawer';
import IssueReceiveModal from '../components/inventory/IssueReceiveModal';
import type { InventoryItem } from '../types';

type Modal = { mode: 'issue' | 'receive'; item: InventoryItem } | null;

export default function Inventory() {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [drawer, setDrawer] = useState<{ item?: InventoryItem } | null>(null);
  const [modal, setModal] = useState<Modal>(null);

  return (
    <div className="h-full flex flex-col">
      <PageHeader
        title="Inventory"
        breadcrumb={[{ label: 'Dashboard', href: '/dashboard' }, { label: 'Inventory' }]}
        actions={
          <button className="btn-primary" onClick={() => setDrawer({})}>
            + Add Part
          </button>
        }
      />

      {/* Two-panel layout */}
      <div className="flex-1 overflow-hidden flex">
        {/* Left panel — list */}
        <div className="w-72 shrink-0 border-r border-gray-200 bg-white flex flex-col overflow-hidden">
          <InventoryList
            selectedId={selectedId}
            onSelect={(item) => setSelectedId(item.id)}
          />
        </div>

        {/* Right panel — detail */}
        <div className="flex-1 overflow-hidden bg-white">
          {selectedId ? (
            <InventoryDetail
              itemId={selectedId}
              onEdit={(item) => setDrawer({ item })}
              onIssue={(item) => setModal({ mode: 'issue', item })}
              onReceive={(item) => setModal({ mode: 'receive', item })}
              onDeleted={() => setSelectedId(null)}
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-full text-center p-8">
              <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
              </div>
              <p className="text-sm text-gray-500">Select a part to view details</p>
            </div>
          )}
        </div>
      </div>

      {/* Edit / Add Drawer */}
      {drawer !== null && (
        <EditDrawer
          item={drawer.item}
          onClose={() => setDrawer(null)}
        />
      )}

      {/* Issue / Receive Modal */}
      {modal && (
        <IssueReceiveModal
          item={modal.item}
          mode={modal.mode}
          onClose={() => setModal(null)}
        />
      )}
    </div>
  );
}
